import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-eca-input',
  templateUrl: './eca-input.component.html',
  styleUrls: ['./eca-input.component.scss']
})
export class EcaInputComponent implements OnInit {
  @Input() value: any;
  @Input() isReadOnly: boolean = true;
  @Input() popoverText: string;
  @Input() isRequired: boolean;
  @Input() inputType: string = "text";
  @Input() label: string;
  @Input() isValid: boolean = true;
  @Input() validationMessage: string = "";
  @Input() pattern: string = "";
  @Input() controlId: string;

  @Output() valueChange : EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {}

  updateValue(value: any) {
    this.value = value;
    this.valueChange.emit(value);
  }
}
